export const environment = {
  ENV: 'staging',
  API_URL: 'https://dev.api.myeinvois.my',
  FILES_URL: 'https://dev.myeinvois.my/brand-files',
  SENTRY_DSN:
    'https://b678067b852025b298bc8896c886c5c7@o4507528086355968.ingest.de.sentry.io/4507528320057424',
  CAPTCHA_KEY: '0x4AAAAAABfwucY0TArCtUXo',
  GTAG_ID: '',
  clarityID: 't4ghlrkusr',
  RSA_PUBLIC_KEY:
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAr9wYPtgkzRkWMZRYsbYTDGESMNLGx+OsP/Mu5P7CT1+JLKks1h0hT/LJIc23TH5wXGY72ltpooYbQbg6ti/8QR7ICj4ZMVYBdzcTbMuqnC9qJtnBGGxKt/TQT2FH5tLDP3rnR+84qSCq1fVlQAMQrqaiDkbIfQerZJ+wIE07yCCDBGz3zBmGVNBKsPssHGpZtYKIZBe9zmDdNnEYJRE1dErZp/LMJodbcHOmjr1Bo60Ka1AIu+kaVUU9jqCHToVhdC+ndzdAf8zEtFOrWAxSDAH/Yrm+3UQG65fX+mVBvlqP9QgcFgVEo+LCx4/Z7ytNpq8E2a7OdbYrLapIR1GWOwIDAQAB',
};
